import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  ICreateLoanTrancheDisbursementApplicationRequest,
  ILoanTrancheDisbursementApplication,
  IUpdateLoanTrancheDisbursementApplicationRequest,
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const loanTrancheDisbursementApplicationApi = createApi({
  reducerPath: "loanTrancheDisbursementApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createLoanTrancheDisbursementApplication: builder.mutation<
      string,
      ICreateLoanTrancheDisbursementApplicationRequest
    >(
      withIdempotency<ICreateLoanTrancheDisbursementApplicationRequest>(
        ApplicationApiUrls.LoanTrancheDisbursementApplication
      )),
    updateLoanTrancheDisbursementApplication: builder.mutation<
      string,
      IUpdateLoanTrancheDisbursementApplicationRequest
    >(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.LoanTrancheDisbursementApplication}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getLoanTrancheDisbursementApplication: builder.query<ILoanTrancheDisbursementApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.LoanTrancheDisbursementApplication}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetLoanTrancheDisbursementApplicationQuery,
  useCreateLoanTrancheDisbursementApplicationMutation,
  useUpdateLoanTrancheDisbursementApplicationMutation,
} = loanTrancheDisbursementApplicationApi;
